import React, { useEffect, useState } from "react";

import { ISubmitValuationAdapter } from "./adapters";
import { MockSubmitValuationAdapter } from "./adapters/mockSubmitValuationAdapter";
import { SubmitValuationAdapter } from "./adapters/submitValuationAdapter";
import { CarsanetClient } from "./clients/carsanet";
import { getFormResources } from "./resources/getResources";
import { AppInputContextState } from "./types/context";
import { FormResources } from "./types/formData";
import { isTokenExpired } from "./utils/isTokenExpired";
import { parseJwt } from "./utils/parseJwt";
import { AppContainer } from "./valuation-manager.styles";
import { ValuationManagerProvider } from "./ValuationManagerContext";
import { ValuationManagerForm } from "./ValuationManagerForm";

function App({ appInput }: { appInput: AppInputContextState }) {
  const rootElement = document.getElementById("root");
  const containerClass = rootElement ? "App" : "App container";

  const [formResources, setFormResources] = useState<FormResources>();
  const [submitValuationAdapter, setSubmitValuationAdapter] =
    useState<ISubmitValuationAdapter>();

  useEffect(() => {
    const fetchFormResources = async () => {
      const resolvedFormResources = await getFormResources();
      setFormResources(resolvedFormResources);
    };
    const getSubmitValuationAdapter = () => {
      const submitValuationAdapter: ISubmitValuationAdapter =
        process.env.NODE_ENV === "production"
          ? new SubmitValuationAdapter(new CarsanetClient(), appInput.jwt)
          : new MockSubmitValuationAdapter();

      setSubmitValuationAdapter(submitValuationAdapter);
    };

    fetchFormResources();
    getSubmitValuationAdapter();
  }, [appInput]);

  if (isTokenExpired(parseJwt(appInput.jwt).exp)) {
    return (
      <AppContainer className={containerClass}>
        <p data-testid="not-authorised">
          Unable to load App, please contact your administrator. Token expired.
        </p>
      </AppContainer>
    );
  }

  return (
    <AppContainer className={containerClass}>
      {formResources && submitValuationAdapter && (
        <ValuationManagerProvider>
          <ValuationManagerForm
            formResources={formResources}
            appInput={appInput}
            submitValuationAdapter={submitValuationAdapter}
          />
        </ValuationManagerProvider>
      )}
    </AppContainer>
  );
}

export default App;
